export default "__VITE_ASSET__2a88ffd6__"